app.MenuCoverList = app.AbstractCollection.extend({
  model: app.MenuCover,

  url() {
    return '/api/v2/menu-covers';
  },
});
